module.exports = __webpack_public_path__ + "img/alert.5e349db5.svg";